/**
 * DashboardActivitiesRecentReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * DashboardActivitiesRecentReq
 */
export interface DashboardActivitiesRecentReq {
  /** 数量限制 */
  limit?: number
}

/**
 * DashboardActivitiesRecentReq Schema
 */
export const DashboardActivitiesRecentReqSchema: SchemaDefinition = {
  properties: {
    limit: {
      default: 10,
      description: '数量限制',
      format: 'int',
      type: 'integer',
      label: '数量限制',
    },
  },
  type: 'object',
}
